import { Services } from '@sigma-frontend-libs/commons'

import { billingsSources, permissionPresets } from '@/utils'

export const sourceItems = service => {
  return {
    computed: {
      sourceItems() {
        const result = []
        const permission = `advanced.${service}.find`

        if (service === Services.billings) {
          result.push(...Object.values(billingsSources))
        }

        if (this.checkPermissions(permission, permissionPresets.meUp)) { // https://gitlab-y7r4iuqy1m.sigmasms.ru/sigma/issues/-/issues/1824
          result.push(...this.getSendingTypesByPermission(permission).map(type => {
            return `${Services.sendings}.${type}`
          }))
          result.push('hlr'),
          result.push('otp.sim_push')
        }

        return result.map(value => {
          const type = value.replace(/sendings\.|subscription\.|otp\./g, '')

          return {
            title: this.getTranslate(`${Services.billings}.sources.${type}`),
            value,
            type
          }
        })
      }
    }
  }
}
